export default __webpack_public_path__ + "static/media/5221.cdbd7b3e.png";